import React from 'react';
import Colors from '../../config/Colors';

import Selection from 'react-select';

export const Select = ({
    selectStyles = { width: 250 },
    optionsStyles,
    singleValueStyles,
    menuStyle,
    options,
    onChange,
    value = null,
    isSearchable = false,
    ref,
    ...props
}) => {
    const customStyles = {
        option: (provided) => ({
            ...provided,
            fontFamily: 'NunitoSans-Regular',
            fontSize: '1.6rem',
            ...optionsStyles
        }),
        control: (provided, state) => {
            return {
                ...provided,
                border: `1px solid ${
                    state.isFocused ? Colors.secondary : Colors.border
                }`,
                fontFamily: 'NunitoSans-Regular',
                fontSize: '1.6rem',
                ...selectStyles
            };
        },
        singleValue: (provided, state) => {
            const opacity = state.isDisabled ? 0.5 : 1;
            const transition = 'opacity 300ms';
            const fontFamily = 'NunitoSans-Regular';
            const fontSize = '1.6rem';
            return {
                ...provided,
                opacity,
                transition,
                fontFamily,
                fontSize,
                ...singleValueStyles
            };
        }
    };

    return (
        <Selection
            noOptionsMessage={() => 'Não há opções'}
            placeholder="Selecione..."
            ref={ref || null}
            isSearchable={isSearchable}
            styles={customStyles}
            options={options}
            onChange={onChange}
            value={value}
            components={{
                IndicatorSeparator: () => null
            }}
            {...props}
        />
    );
};
